import React, { lazy, Suspense } from "react";
import ExecutionEnvironment from "exenv";

// Components
import CustomMeta from "../components/CustomMeta/CustomMeta";
const Profile = lazy(() =>
  import(/* webpackChunkName: "Profile" */ "../components/Profile/Profile")
);
const AuthorizedSocialMediaProfiles = lazy(() =>
  import(
    /* webpackChunkName: "AuthorizedSocialMediaProfiles" */ "../components/Profile/AuthorizedSocialMediaProfiles"
  )
);
const LoginOrSignup = lazy(() =>
  import(
    /* webpackChunkName: "LoginOrSignup" */ "../components/Login/LoginOrSignup"
  )
);
const APKeyDetails = lazy(() =>
  import(
    /* webpackChunkName: "APKeyDetails" */ "../components/Profile/APKeyDetails"
  )
);
const AccountManagement = lazy(() =>
  import(
    /* webpackChunkName: "APKeyDetails" */ "../components/Profile/AccountManagement"
  )
);
const ReferralBlock = lazy(() =>
  import(
    /* webpackChunkName: "ReferralBlock" */ "../components/Referrals/ReferralsBlock"
  )
);
const WebsiteWhitelisting = lazy(() =>
  import(
    /* webpackChunkName: "WebsiteWhitelisting" */ "../components/Profile/WebsiteWhitelisting"
  )
);

// MUI stuff
import Grid from "@mui/material/Grid2";
import { makeStyles } from "tss-react/mui";
import CircularProgress from "@mui/material/CircularProgress";

// redux stuff
import { connect } from "react-redux";

const useStyles = makeStyles()((theme) => ({
  fullPageHeight: {
    minHeight: "100vh",
    width: "100%",
  },
  root: {
    flexGrow: 1,
    padding: 16,
    maxWidth: 1237,
    margin: "auto",
  },
  profileDiv: {
    display: "inline-flex",
    justifyContent: "center",
  },
  loadingOverlay: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "rgba(255, 255, 255, 1)",
    zIndex: 1000,
  },
  contentWrapper: {
    position: "relative",
    width: "100%",
  },
  blocks: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(1),
  },
}));

function profile(props) {
  const { classes } = useStyles();

  return (
    <div className={classes.fullPageHeight}>
      <CustomMeta
        title={`Profile - Content Generator Account Settings`}
        description={`Access your Content Generator account settings to manage your profile, subscription, and more. Update your account details, billing information, and marketing settings in one place.`}
        url={`https://contentgenerator.io/profile`}
      />
      {ExecutionEnvironment.canUseDOM && (
        <Suspense fallback={<div />}>
          <div className={classes.contentWrapper}>
            {props.user.loading && (
              <div className={classes.loadingOverlay}>
                <CircularProgress size={25} />
              </div>
            )}
            <Grid
              container
              className={classes.root}
              spacing={2}
              sx={{
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "flex-start",
              }}
            >
              {props.user.authenticated ? (
                <Grid container spacing={3}>
                  <Grid
                    size={{ xs: 12, sm: 12, md: 6 }}
                    className={classes.blocks}
                  >
                    <Profile />
                    <ReferralBlock />
                    <WebsiteWhitelisting />
                    <APKeyDetails />
                    <AccountManagement />
                  </Grid>
                  <Grid
                    size={{ xs: 12, sm: 12, md: 6 }}
                    className={classes.blocks}
                  >
                    <AuthorizedSocialMediaProfiles />
                  </Grid>
                </Grid>
              ) : (
                <Grid container spacing={3}>
                  <Grid size={12}>
                    <LoginOrSignup />
                  </Grid>
                </Grid>
              )}
            </Grid>
          </div>
        </Suspense>
      )}
    </div>
  );
}

const mapStateToProps = (state) => ({
  data: state.data,
  user: state.user,
});

export default connect(mapStateToProps)(profile);
